// What the composer accepts, and how an attachment is drawn. Mirrors the
// server's allow-list in src/utils/chatAttachments.js — keep the two in step.
// The server is the enforcer; this is only so a user picking a .zip is told
// before they wait for a 25MB upload to be refused.

export const ACCEPT = '.jpg,.jpeg,.png,.gif,.webp,.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt';
export const MAX_BYTES = 25 * 1024 * 1024;

const EXT_KIND = {
  jpg: 'image', jpeg: 'image', png: 'image', gif: 'image', webp: 'image', heic: 'image',
  pdf: 'pdf',
  doc: 'doc', docx: 'doc', txt: 'doc',
  xls: 'sheet', xlsx: 'sheet', csv: 'sheet',
};

export const KIND_ICON = { image: '🖼️', pdf: '📕', sheet: '📊', doc: '📄' };

export const kindOf = (file) => EXT_KIND[(file.name || '').split('.').pop()?.toLowerCase()] || null;

export function checkFile(file) {
  if (!file) return 'Choose a file to send';
  if (file.size === 0) return 'That file is empty';
  if (file.size > MAX_BYTES) return 'That file is larger than the 25MB limit';
  if (!kindOf(file)) return 'Only images, PDF, Word, Excel, CSV and text files can be sent';
  return null;
}

export function fmtSize(bytes) {
  const b = Number(bytes || 0);
  if (b < 1024) return `${b} B`;
  if (b < 1024 * 1024) return `${Math.round(b / 1024)} KB`;
  return `${(b / (1024 * 1024)).toFixed(1)} MB`;
}

// A one-line summary of a message for the reply strip / inbox preview, so an
// attachment-only message never renders as an empty quote.
export function summarise(msg) {
  if (!msg) return '';
  if (msg.isDeleted) return 'Message removed';
  if (msg.body) return msg.body;
  const files = msg.attachments || [];
  if (files.length === 1) return `${KIND_ICON[files[0].kind] || '📎'} ${files[0].fileName}`;
  if (files.length > 1) return `📎 ${files.length} files`;
  return '';
}
